import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const BreadcrumbSeperatorIcon = (props) => {
    return (
        <Icon
            viewBox="0 0 16 18"
            data-testid="breadcrumb-seperator-icon"
            aria-hidden="true"
            {...props}
        >
            <rect x="4" y="4" width="1.5" height="10" rx="0.75" fill="currentColor" />
            <rect x="7.25" y="4" width="1.5" height="10" rx="0.75" fill="currentColor" />
            <rect x="10.5" y="4" width="1.5" height="10" rx="0.75" fill="currentColor" />
        </Icon>
    )
}

BreadcrumbSeperatorIcon.propTypes = {
    color: PropTypes.string,
}

export default BreadcrumbSeperatorIcon
